import { BaseConfig } from "../config.interface";

interface ITableSelectConfig {}

export class TableSelectConfig extends BaseConfig<ITableSelectConfig> implements ITableSelectConfig {

    /**
     * @theme Base
     */
    static baseTheme = {
        /**
         * Default configuration.
         */
        Default: new TableSelectConfig({}),
    };
}
